import { Pipe, PipeTransform } from '@angular/core';
import { ROWPOSITION } from 'src/app/shared/components/field-item/field-item.model';
import {FieldItemRowService} from '../services/row/row.service';


@Pipe({
  name: 'isRowOrColumn',
  standalone: false
})
export class IsRowOrColumnPipe implements PipeTransform {
   constructor (private sFieldItemRow: FieldItemRowService) {}

   transform (fieldType: string, isRowOrColumn?: ROWPOSITION): string {
      return this.sFieldItemRow.isRowOrColumn(fieldType, isRowOrColumn);
   }
}